<script lang="ts">
  import { fly } from 'svelte/transition';
  export let image: string;
  export let scale: string = '1';

  function preload(src) {
    return new Promise(function (resolve) {
      let img = new Image();
      img.onload = resolve;
      img.src = src;
    });
  }
</script>

<div class="animated-coin-container" style="transform: scale({scale})">
  {#await preload(image) then _}
    <div class="animated-coin" in:fly>
      <div class="animated-coin-front">
        <div
          class="animated-coin-image"
          style="background-image: url({image})"
        />
      </div>
      <div class="animated-coin-edge">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <div class="animated-coin-back">
        <div
          class="animated-coin-image"
          style="background-image: url({image})"
        />
      </div>
      <div class="animated-coin-shadow" />
    </div>
  {/await}
</div>

<style lang="scss">
  $coin-diameter: 80px;
  $coin-thickness: 5px;
  $coin-color: #e6e6e6;
  $edge-faces: 160;
  $edge-face-length: 3.14 * $coin-diameter / $edge-faces;

  .animated-coin {
    position: relative;
    width: $coin-diameter;
    height: $coin-diameter;
    transform-style: preserve-3d;
    animation: rotate3d 4s cubic-bezier(0.3, 1, 0.7, 0) infinite;
    transition: all 0.3s;
    z-index: 2;
  }

  .animated-coin-front,
  .animated-coin-back {
    position: absolute;
    width: $coin-diameter;
    height: $coin-diameter;
    border-radius: 50%;
    overflow: hidden;
    background-color: $coin-color;

    .animated-coin-image {
      width: $coin-diameter - 10;
      height: $coin-diameter - 10;
      position: absolute;
      top: 5px;
      left: 5px;
      overflow: hidden;
      border-radius: 50%;
      background-size: cover;

      &:before {
        content: '';
        width: $coin-diameter - 10;
        height: $coin-diameter - 10;
        position: absolute;
        top: 0;
        left: 0;
        overflow: hidden;
        border-radius: 50%;
        background-color: $coin-color;
        z-index: -1;
      }
    }

    &:before {
      content: '';
      position: absolute;
      width: 9px;
      height: 9px;
      background-image: url('/images/shine.svg');
      z-index: 2;
    }

    &:after {
      content: '';
      position: absolute;
      left: -$coin-diameter/2;
      bottom: 100%;
      display: block;
      height: $coin-diameter/1.5;
      width: $coin-diameter * 2;
      background: #fff;
      opacity: 0.3;
      animation: shine linear 4s infinite;
    }
  }

  .animated-coin-front {
    transform: translateZ($coin-thickness/2);

    &:before {
      top: 5px;
      right: 18px;
    }
  }
  .animated-coin-back {
    transform: translateZ(-$coin-thickness/2) rotateY(180deg);

    &:before {
      top: 5px;
      right: 18px;
    }
  }

  .animated-coin-edge {
    transform-style: preserve-3d;

    @for $i from 1 through $edge-faces {
      div:nth-child(#{$i}) {
        position: absolute;
        height: $edge-face-length;
        width: $coin-thickness;
        background: darken(
          #e6e6e6,
          (($i - $edge-faces/2) * ($i - $edge-faces/2)) /
            ($edge-faces * $edge-faces/4) *
            100 *
            0.7
        );
        transform: translateY(#{$coin-diameter / 2 - $edge-face-length / 2})
          translateX(#{$coin-diameter / 2 - $coin-thickness / 2})
          rotateZ(360deg / $edge-faces * $i + 90)
          translateX(#{$coin-diameter / 2})
          rotateY(90deg);
      }
    }
  }

  .animated-coin-shadow {
    position: absolute;
    width: $coin-diameter;
    height: $coin-thickness;
    border-radius: 50%;
    background: #000;
    box-shadow: 0 0 $coin-thickness * 5 $coin-thickness * 5 #000;
    opacity: 0.125;
    transform: rotateX(90deg) translateZ(-$coin-diameter * 1.1) scale(0.5);
  }

  @keyframes rotate3d {
    0% {
      transform: perspective(1000px) rotateY(0deg);
    }

    100% {
      transform: perspective(1000px) rotateY(360deg);
    }
  }

  @keyframes shine {
    0%,
    15% {
      transform: translateY($coin-diameter * 2) rotate(-40deg);
    }
    50% {
      transform: translateY(-$coin-diameter) rotate(-40deg);
    }
  }
</style>
